import { apiClient } from './api'

export interface ChatMessage {
  role: 'user' | 'assistant'
  content: string
}

export interface ChatResponse {
  message: string
  role: string
}

export interface ChatRequestMeta {
  projectId?: number
  programId?: number
}

/**
 * Send conversation history to the AI chat endpoint and get the assistant reply.
 */
export async function sendChatMessage(
  messages: ChatMessage[],
  meta?: ChatRequestMeta,
): Promise<ChatResponse> {
  const { data } = await apiClient.post<ChatResponse>('/api/v1/ai/chat', {
    messages: messages.map((m) => ({ role: m.role, content: m.content })),
    project_id: meta?.projectId,
    program_id: meta?.programId,
  })
  return data
}
